// @ts-nocheck

import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import KLIcon from '../../modules/koh-lanta/components/KLIcon';
import {
  MenuDesktopArrowIcon,
  SportsMenuBtnContent,
  SportsMenuBtnLabel,
  SportsMenuListItem,
} from '../../styled-components/shared';
import Counter from '../Counter';

const StyledSportsMenuListItem = styled(SportsMenuListItem)`
  --mask-bg: #1f222e;
  --mask-transition: 480ms;
  --mask-transition-timing-function: ease-out;

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          --mask-bg: #43485a;
          --mask-transition: 245ms;
          --mask-transition-function: ease-in;
        }
      `
    : undefined}
`;

const StyledCounter = styled(Counter)`
  width: 1.6em;
  height: 1.6em;
  font-weight: bold;
  font-size: 94%;
`;

const StyledKLIcon = styled(KLIcon)`
  margin: 0 0.25em;
`;

type MenuDestkopKLButtonProps = {
  nbKLNotifications: number;
  openKLView: () => void;
};

const MenuDestkopKLButton = ({ nbKLNotifications, openKLView }: MenuDestkopKLButtonProps) => {
  return (
    <StyledSportsMenuListItem onClick={openKLView}>
      <SportsMenuBtnContent>
        <StyledKLIcon disableAnimation={!nbKLNotifications} />
        <SportsMenuBtnLabel $separator={true}>
          Koh-Lanta{nbKLNotifications ? <StyledCounter counter={nbKLNotifications} /> : null}
        </SportsMenuBtnLabel>
      </SportsMenuBtnContent>
      <MenuDesktopArrowIcon className="see-all-btn" />
    </StyledSportsMenuListItem>
  );
};

export default memo<MenuDestkopKLButtonProps>(MenuDestkopKLButton);
